import React from 'react';
import { MdOutlineArrowBackIos } from 'react-icons/md';
import sadSchoolEngineLogo from '../assets/SE_sad.svg';
import './apiError.css';

const defaultErrorMessage = 'There was a problem retrieving the data. Please try again, or contact us if the issue continues.';

// Display the shared API failure state and return the user to their previous screen.
export function ApiError({ message = defaultErrorMessage }) {
    return (
        <section className="api-error" aria-labelledby="api-error-title">
            <img
                className="api-error__logo"
                src={sadSchoolEngineLogo}
                alt=""
                aria-hidden="true"
            />
            <h1 className="api-error__title" id="api-error-title">We're sorry</h1>
            <p className="api-error__message">{message || defaultErrorMessage}</p>
            <button
                className="api-error__button"
                type="button"
                onClick={() => window.history.back()}
            >
                <MdOutlineArrowBackIos className="api-error__button-icon" aria-hidden="true" />
                Go back
            </button>
        </section>
    );
}
